export const Login = () => {
  return (
    <div className="max-w-lg mx-auto px-4 mt-16">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">Login</h1>
        <p className="text-gray-500">Login page coming soon...</p>
      </div>
    </div>
  )
}

export default Login
